import React, { useState } from "react";

const App = () => {
  const [images, setImages] = useState([
    {
      id: 1,
      url: "https://placehold.co/150x200/F0D9E7/121A20?text=Image+1",
      alt: "Medical treatment app promotion",
    },
    {
      id: 2,
      url: "https://placehold.co/150x200/D7E6ED/121A20?text=Image+2",
      alt: "Hindi text for medicine promotion",
    },
    {
      id: 3,
      url: "https://placehold.co/150x200/D4D4D2/121A20?text=Image+3",
      alt: "Heel pain treatment promotion",
    },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [newUrl, setNewUrl] = useState("");

  const handleEdit = (image) => {
    setCurrentImage(image);
    setNewUrl(image.url);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentImage(null);
    setNewUrl("");
  };

  const handleSave = () => {
    if (currentImage && newUrl) {
      const updatedImages = images.map((img) =>
        img.id === currentImage.id ? { ...img, url: newUrl } : img
      );
      setImages(updatedImages);
      handleCloseModal();
    }
  };
  return (
    <div className="container">
      <style>{`
        .container {
          min-height: 100vh;
          background-color: #f3f4f6;
          padding: 1rem;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
          margin: 0;
        }

        .inner-container {
          width: 100%;
          margin: 0;
        }

        /* Desktop margin (unchanged) */
        @media (min-width: 1024px) {
          .inner-container {
            margin-left: 230px;
            width: 99%;
          }
        }

        .main-content {
          border-radius: 0.75rem;
          background-color: #fff;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05);
        }

        .table-header {
          background-color: #2fb2e7;
          padding: 1rem;
          border-top-left-radius: 0.75rem;
          border-top-right-radius: 0.75rem;
          color: #fff;
        }

        .table-container {
          overflow-x: auto;
        }

        .data-table {
          width: 100%;
          border-collapse: collapse;
        }

        /* --------- ✅ MOBILE VIEW ONLY --------- */
        @media (max-width: 767px) {
          .data-table thead {
            display: none; /* hide header */
            
          }

          .data-table tbody tr {
            display: block;
            margin-bottom: 1rem;
            border: 1px solid #e5e7eb;
            background: #fff;
            border-radius: 0.5rem;
            padding: 0.75rem;
          }

          .data-table td {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.5rem 0;
            
            font-size: 0.9rem;
          }

          .data-table td[data-label]::before {
            content: attr(data-label);
            font-weight: 600;
            color: #374151;
            margin-right: 0.5rem;
          }

          .image-cell {
            flex-direction: column;
            align-items: flex-start;
          }

          .image-cell img {
            height: 4rem;
            width: 4rem;
            margin-bottom: 0.5rem;
          }

          .action-cell {
            justify-content: flex-start;
          }
        }
        /* --------- END MOBILE --------- */

        /* Desktop stays as is */
        @media (min-width: 768px) {
          .data-table thead {
            display: table-header-group;
          }
          .data-table tbody tr {
            display: table-row;
            border: none;
            padding: 0;
          }
          .data-table td {
            display: table-cell;
            padding: 0.75rem 9rem;
            text-align: left;
            border-bottom: 1px solid #e5e7eb;
          }
          .data-table td[data-label]::before {
            content: none;
          }
        }

        .image-cell {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .image-cell img {
          height: 5rem;
          width: auto;
          border-radius: 0.5rem;
          object-fit: cover;
          flex-shrink: 0;
        }

        .action-cell {
          display: flex;
          justify-content: flex-end;
          gap: 0.5rem;
        }

        .action-btn {
          background: #2fb2e7;
          border: none;
          border-radius: 9999px;
          width: 2rem;
          height: 2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: white;
        }

        /* Modal */
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 50;
          padding: 1rem;
        }

        .modal-content {
          background: #fff;
          border-radius: 0.75rem;
          max-width: 28rem;
          width: 100%;
          padding: 1.5rem;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #eee;
          margin-bottom: 1rem;
        }

        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 0.5rem;
        }

        .cancel-btn, .save-btn {
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          border: none;
          cursor: pointer;
        }

        .cancel-btn { background: #e5e7eb; }
        .save-btn { background: #4f46e5; color: #fff; }
      `}</style>

      <div className="inner-container">
        <main className="main-content">
          <div className="table-header">
            <h2>Image Information</h2>
          </div>

          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>S No</th>
                  <th>Image</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {images.map((image, index) => (
                  <tr key={image.id}>
                    <td data-label="S No">{index + 1}</td>
                    <td data-label="Image" className="image-cell">
                      <img src={image.url} alt={image.alt} />
                      <span>{image.alt}</span>
                    </td>
                    <td data-label="Action" className="action-cell">
                      <button
                        className="action-btn"
                        onClick={() => handleEdit(image)}
                      >
                        ✏️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>

        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h3>Edit Image URL</h3>
                <button onClick={handleCloseModal}>✖</button>
              </div>
              <div className="form-group">
                <label htmlFor="imageUrl">Image URL</label>
                <input
                  type="text"
                  id="imageUrl"
                  value={newUrl}
                  onChange={(e) => setNewUrl(e.target.value)}
                  style={{ width: "100%", padding: "0.5rem" }}
                />
              </div>
              <div className="modal-actions">
                <button className="cancel-btn" onClick={handleCloseModal}>
                  Cancel
                </button>
                <button className="save-btn" onClick={handleSave}>
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default App;
